import axios from '@/common/axios'
import API from '@/config/apis'

//请求服务点的列表
export function getServicePointList(params) {
    return new Promise(function (resolve, reject) {
        axios('post', API.PROFILE.ServiceList, params)
            .then(function (result) {
                resolve(result.data)
            })
    })
}
//请求营销点的列表
export function getServicePointList2(params) {
    return new Promise(function (resolve, reject) {
        axios('post', API.PROFILE.ServiceList2, params)
            .then(function (result) {
                resolve(result.data)
            })
    })
}
// 请求公banner图
export function getBanner(params) {

    return new Promise(function (resolve, reject) {
        axios('post', API.PROFILE.BANNER, params)
            .then(function (result) {
                resolve(result.data)
            })
    })

}

// 请求海外市场内容
export function getService(params) {

    return new Promise(function (resolve, reject) {
        axios('post', API.PROFILE.DETAIL, params)
            .then(function (result) {
                resolve(result.data)
            })
    })

}
